<script setup lang="ts">
import {getCurrentInstance, ref, defineEmits} from "vue";
import {useStore} from "vuex";
  const { $alert } = getCurrentInstance().appContext.config.globalProperties;
  const { $axios } = getCurrentInstance().appContext.config.globalProperties;
  const { $endpoint } = getCurrentInstance().appContext.config.globalProperties;
  const emit = defineEmits(['customerFound'])
  const store = useStore()
  const contactSearch = ref(store.getters['booking/getCustomer']?.cust_contact)
  const checkCustomerInfos = ()=>{
    if (contactSearch.value.length ===10){
      $axios.get($endpoint.CheckCustomerInfosByContact(contactSearch.value)).then((resp_cust:any)=>{
        store.dispatch('booking/saveCustomer', resp_cust.data.data)
        store.dispatch('booking/saveNewCustomer',false)
        emit('customerFound')
      }).catch((err:any)=>{
        console.log(err)
      })
    }else {
      $alert.fire({
        title: 'Ooops!',
        text: "Veuillez renseigné un contact correct (10 chiffres)",
        icon: 'error',
        confirmButtonColor:'#D62F2F',
        confirmButtonText: 'Compris'
      })

    }
  }
</script>

<template>
<div class="uk-container-large uk-margin-top border-outline">
  <h6 class="uk-heading-line uk-text-center uk-text-secondary uk-text-uppercase uk-text-bold"><span>Vérifier votre enregistrement à partir de votre contact </span></h6>
  <form class="uk-grid-small" data-uk-grid>
    <div class="uk-margin uk-width-1-1@s uk-width-1-2@l uk-width-1-2@xl uk-form-controls">
      <div class="uk-inline">
        <span class="uk-form-icon uk-form-icon-flip" uk-icon="icon: phone"></span>
        <input v-model="contactSearch" class="uk-input uk-input uk-form-width-large uk-border-rounded csa-input" placeholder="Contact pendant l'enregistrement" type="text" aria-label="Not clickable icon">
      </div>
    </div>
    <div class=" uk-width-1-1@s uk-width-1-2@l uk-width-1-2@xl">
      <button type="button" class="uk-button csa-btn" @click="checkCustomerInfos()">Rechercher</button>
    </div>
  </form>
</div>
</template>

<style scoped>

</style>